import Card from "@rio-cloud/rio-uikit/Card";
import DRERow from "./DRERow";
import { Button } from "@rio-cloud/rio-uikit";
import type { DREHierarchicalLine, DRELineType, DRENodeType, DREParentPath } from "../../../types/dashboard";
import DownloadButton from "./downloadButton";

export interface ExpandNodeParams {
  nodeId: string;
  compositeId: string;
  nodeType: DRENodeType;
  lineType: DRELineType;
  parentPath?: DREParentPath;
}

interface DRETableProps {
  data: DREHierarchicalLine[];
  expandedItems: string[];
  loadingNodes: string[];
  onToggle: (id: string) => void;
  onExpandNode: (params: ExpandNodeParams) => Promise<void>;
  onDownload?: () => void;
}

export default function DRETable({
  data,
  expandedItems,
  loadingNodes,
  onToggle,
  onExpandNode,
  onDownload,
}: DRETableProps) {
  return (
    <Card className="padding-y-20 padding-x-50 margin-bottom-20">
      <div className="display-flex align-items-center justify-content-between gap-10 padding-bottom-20">
        <span className="text-size-16 text-bold">DRE (Demonstrativo de Resultado do Exercício)</span>
        <DownloadButton
          items={[
            {
              icon: "rioglyph rioglyph-search-list ",
              onClick: () => console.log("clicou"),
              title: "Visão geral",
            },
            {
              icon: "rioglyph rioglyph-building",
              onClick: () => console.log("clicou"),
              title: "Filial",
            },
            {
              icon: "rioglyph rioglyph-role-management",
              onClick: () => console.log("clicou"),
              title: "Segmento",
            },
            {
              icon: "rioglyph rioglyph-truck",
              onClick: () => console.log("clicou"),
              title: "Veículo",
            },
            {
              icon: "rioglyph rioglyph-driver",
              onClick: () => console.log("clicou"),
              title: "Motorista",
            },
          ]}
        />
      </div>

      {data.map((item, index) => (
        <DRERow
          item={item}
          key={item.id}
          lineType={item.lineType}
          onToggle={onToggle}
          expandedItems={expandedItems}
          loadingNodes={loadingNodes}
          onExpandNode={onExpandNode}
          isLast={index === data.length - 1}
          depth={item.level}
        />
      ))}
    </Card>
  );
}
